module.exports = __webpack_public_path__ + "img/TBB4.82cac4ef.jpg";